import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ImageSlider from './ImageSilder';
import ProductDetails from './ProductDetails';
import ClothsDetails from './ClothsDetails';
import BrandShipping from './BrandShipping';

const ProductPageContain = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs pageTitle='Product Page' parent='Ecommerce' title='Product Page' />
        <div>
          <Row className='product-page-main p-0'>
            <Col xl='5' md='6' className='box-col-7 xl-50'>
              <Card>
                <CardBody>
                  <Row>
                    <ImageSlider />
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <ProductDetails />
            <BrandShipping />
          </Row>
        </div>
        <Card>
          <Row className='product-page-main'>
            <Col sm='12'>
              <ClothsDetails />
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
};
export default ProductPageContain;
